import { AbstractControl, ValidatorFn } from '@angular/forms'

export function requiredIfRelatedFieldIsEmpty(fieldNames: string | string[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.parent) {
      return null
    }

    const relatedFieldNames = Array.isArray(fieldNames) ? fieldNames : [fieldNames]

    const relatedFields = relatedFieldNames.map((name) => control.parent?.get(String(name ?? ''))).filter(Boolean)
    const relatedFieldsHasValue = relatedFields.some((field) => field?.value && field?.value.length > 0)
    const controlHasValue = control.value && control.value.length > 0

    if (relatedFieldsHasValue) {
      return null
    }

    if (!controlHasValue) {
      return { requiredIf: true }
    }

    relatedFields.forEach((field) => field.updateValueAndValidity())

    return null
  }
}
